export const PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL";
export const PRODUCT_LIST_RESET = "PRODUCT_LIST_RESET";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";

export const PRODUCT_CREATE_REQUEST = "PRODUCT_CREATE_REQUEST";
export const PRODUCT_CREATE_SUCCESS = "PRODUCT_CREATE_SUCCESS";
export const PRODUCT_CREATE_FAIL = "PRODUCT_CREATE_FAIL";
export const PRODUCT_CREATE_RESET = "PRODUCT_CREATE_RESET";

export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_FAIL = "PRODUCT_UPDATE_FAIL";
export const PRODUCT_UPDATE_RESET = "PRODUCT_UPDATE_RESET";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAIL = "PRODUCT_DELETE_FAIL";
export const PRODUCT_DELETE_RESET = "PRODUCT_DELETE_RESET";

export const PRODUCT_IMAGES_REQUEST = "PRODUCT_IMAGES_REQUEST";
export const PRODUCT_IMAGES_SUCCESS = "PRODUCT_IMAGES_SUCCESS";
export const PRODUCT_IMAGES_FAIL = "PRODUCT_IMAGES_FAIL";

export const PRODUCT_VARIATION_REQUEST = "PRODUCT_VARIATION_REQUEST";
export const PRODUCT_VARIATION_SUCCESS = "PRODUCT_VARIATION_SUCCESS";
export const PRODUCT_VARIATION_FAIL = "PRODUCT_VARIATION_FAIL";
export const PRODUCT_VARIATION_RESET = "PRODUCT_VARIATION_RESET";

export const PRODUCT_VARIATION_UPDATE_REQUEST =
  "PRODUCT_VARIATION_UPDATE_REQUEST";
export const PRODUCT_VARIATION_UPDATE_SUCCESS =
  "PRODUCT_VARIATION_UPDATE_SUCCESS";
export const PRODUCT_VARIATION_UPDATE_FAIL = "PRODUCT_VARIATION_UPDATE_FAIL";

export const PRODUCT_DEAL_REQUEST = "PRODUCT_DEAL_REQUEST";
export const PRODUCT_DEAL_SUCCESS = "PRODUCT_DEAL_SUCCESS";
export const PRODUCT_DEAL_FAIL = "PRODUCT_DEAL_FAIL";

export const PRODUCT_REVIEW_CREATE_REQUEST = "PRODUCT_REVIEW_CREATE_REQUEST";
export const PRODUCT_REVIEW_CREATE_SUCCESS = "PRODUCT_REVIEW_CREATE_SUCCESS";
export const PRODUCT_REVIEW_CREATE_FAIL = "PRODUCT_REVIEW_CREATE_FAIL";
export const PRODUCT_REVIEW_CREATE_RESET = "PRODUCT_REVIEW_CREATE_RESET";
